import { makeRequest } from "../helpers/api.helpers";
const API_URL = import.meta.env.VITE_API_URL;

type ValidationObj = {
  resultadoFinal: string;
  jurValidation: {
    status: boolean;
    validated: boolean;
    details: string;
    timestamp: Date;
  };
};

export async function validatePuxaCapivara(
  cpf: string,
  entityId: string,
  entityName: string
) {
  const url = `${API_URL}/netrin/legalcheck`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cpf, entityId, entityName }),
  };

  return makeRequest<ValidationObj>(url, options);
}
